export default "__VITE_ASSET__BUqzrptv__"